import React from 'react';
import ReactDOM from 'react-dom';

import registerServiceWorker from './registerServiceWorker';
//REDUCERS
import bilAppReducer from "./Reducers";
//STORES
import { createStore, applyMiddleware } from "redux";
//THUNK
import thunkMiddleware from "redux-thunk";
//MIDDLEWARES
import api from "./Middlewares/api";
//MUI THEME
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
//ROUTER
import { Router, Route, Switch } from "react-router";
//PROVIDER
import { Provider } from "react-redux";
//COMPONENTS
import ErrorBoundary from "./Components/component_ErrorHandler.js";
import PageNotFound  from "./Components/component_PageNotFound.js";

//CONTAINERS
import LoginContainer        from "./Containers/Login"; 
import Home                  from "./Containers/Home"; 
import Pesate                from "./Containers/Pesate"; 
import Bilance               from "./Containers/Bilance"; 
import Impianti              from "./Containers/Impianti"; 
import Aziende               from "./Containers/Aziende"; 
import CampiPersonalizzati   from "./Containers/Campi"; 
import TabellePersonalizzate from "./Containers/Tabelle"; 
import Operatori             from "./Containers/Operatori"; 
import Impostazioni          from "./Containers/Impostazioni"; 
import Stampanti             from "./Containers/Stampanti"; 
import Stampe                from "./Containers/Stampe"; 
import ConfermaEmail         from "./Containers/ConfermaEmail";
import Holding               from "./Containers/Holding";
import RecuperaPassword      from "./Containers/RecuperaPassword";
import Registrazione         from "./Containers/Registrazione";
import SceltaVersione        from "./Containers/SceltaVersione";
import Upgrade               from "./Containers/Upgrade";
import Index                 from "./Containers/Index";

//STRINGS
import * as ROUTE from "./Utils/Strings/Route";
//STYLES
import './CSS/App.css';
import "./CSS/style_general.css";

import createBrowserHistory from 'history/createBrowserHistory';

let history = createBrowserHistory();

let createStoreWithMiddleware = applyMiddleware(thunkMiddleware, api)(createStore);


let store = createStoreWithMiddleware(bilAppReducer);


let rootElement = document.getElementById("root");

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: "#6b9add"
  },
  datePicker: {
    selectColor: "#6b9add"
  }
});

ReactDOM.render(
  <ErrorBoundary>
  <Provider store={store}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <Router history={history}>
        <Switch>
          <Route path={ROUTE.Root}              component={Index}                 exact={true} />
          <Route path={ROUTE.Home}              component={Home}                  onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Weigh}             component={Pesate}                onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Libras}            component={Bilance}               onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Plants}            component={Impianti}              onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Companies}         component={Aziende}               onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Fields}            component={CampiPersonalizzati}   onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Tables}            component={TabellePersonalizzate} onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Operators}         component={Operatori}             onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Settings}          component={Impostazioni}          onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Printers}          component={Stampanti}             onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Prints}            component={Stampe}                onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.EmailConfirmation} component={ConfermaEmail}         onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Holding}           component={Holding}               onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.RecoverPassword}   component={RecuperaPassword}      onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.SignIn}            component={Registrazione}         onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.ChooseVersion}     component={SceltaVersione}        onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Upgrade}           component={Upgrade}               onEnter = {()=> console.log("")}/>
          <Route path={ROUTE.Other}             component={PageNotFound}          onEnter = {()=> console.log("")}/>
        </Switch>
      </Router>
    </MuiThemeProvider>
  </Provider>
  </ErrorBoundary>,
  rootElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js